import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import AccordionWrapper from '../../accordion/accordionWrapper';
import handleCTAClick from '../../../services/helpers/handleCTAClick';
import styles from './commonTableMobile.module.scss';

export default function CommonTableMobile({
  title = '',
  description = '',
  cta = null,
  tableData = [],
  tableHeader = [],
}) {
  let expandable = false;
  const data = tableData
    .filter((items) => !items.hideOnMobile)
    .map((items, index) => {
      const key = `table-${index}`;
      expandable = items.expandedOnMobile || false;
      const head = [];
      const headContent = [];
      const body = [];
      items.rows.map((item, index1) => {
        const key1 = index1;
        if (index1 < 2) {
          head.push(
            <th key={`tableHead-${key1}`}>{parse(tableHeader[index1])}</th>
          );
          headContent.push(
            <td key={`tableContent-${key1}`}>
              {item.value ? parse(item.value) : ''}
              {item.cta && (
                <div className={styles.ctaWrapper}>
                  <CtaButton
                    label={item.cta.label}
                    aria-label={item.cta.label}
                    data-testid={`${item.cta.label}-${index}-${index1}`}
                    color={item.cta.color}
                    variant={item.cta.variant || 'solid'}
                    fullWidth
                    href={item.cta.link}
                    onClick={(e) => handleCTAClick(e, item.cta)}
                  />
                </div>
              )}
            </td>
          );
        } else {
          body.push(
            <tr key={`table-${key1}`}>
              <th>{parse(tableHeader[index1])}</th>
              <td>
                {item?.value ? parse(item.value) : ''}
                {item?.cta && (
                  <div className={styles.ctaWrapper}>
                    <CtaButton
                      label={item.cta.label}
                      aria-label={item.cta?.label}
                      data-testid={`${item.cta?.label}-${index}-${index1}`}
                      color={item.cta.color}
                      variant={item.cta.variant || 'solid'}
                      fullWidth
                      href={item.cta?.link}
                      onClick={(e) => handleCTAClick(e, item.cta)}
                    />
                  </div>
                )}
              </td>
            </tr>
          );
        }
        return {
          id: `table-${index1}`,
          head,
          body,
          headContent,
        };
      });
      return (
        <AccordionWrapper
          key={key}
          id={key}
          head={
            <table className={styles.accordionHeader}>
              <tbody>
                <tr key={`head-${key}`}>{head}</tr>
                <tr key={`headContent-${key}`}>{headContent}</tr>
              </tbody>
            </table>
          }
          body={
            <table className={styles.accordionBody}>
              <tbody>{body}</tbody>
            </table>
          }
          headStyle={styles.accordionHeader}
          borderBottom={
            tableData.filter((content) => !content.hideOnMobile).length - 1 ===
            index
          }
          expanded={expandable}
        />
      );
    });

  return (
    <Grid className={styles.commonTableMobile} container spacing={0}>
      <Grid item xs={12}>
        <div className={styles.titleContainer}>
          {title && <h2 className={styles.title}> {title} </h2>}
        </div>
      </Grid>
      <Grid item xs={12}>
        <div className={styles.accordion}>{data}</div>
      </Grid>
      <Grid item xs={12}>
        <div className={styles.description}>{parse(`${description}`)}</div>
      </Grid>
      {cta && (
        <Grid item xs={12}>
          <div className={styles.ctaContainer}>
            <CtaButton
              label={cta.label}
              color={cta.color}
              variant={cta.variant}
              className={styles.cta}
              href={cta.link}
            />
          </div>
        </Grid>
      )}
    </Grid>
  );
}

CommonTableMobile.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
  tableHeader: PropTypes.array,
  tableData: PropTypes.array,
};
